import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './ui/Button';
import { useLanguage } from '../hooks/useLanguage';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    t
  } = useLanguage();
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past 800px (roughly past hero)
      if (window.scrollY > 800) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-71">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-[#0A0A0F]/90 backdrop-blur-lg border-t border-white/10" data-id="element-72">
          <div className="max-w-5xl mx-auto flex items-center justify-between gap-4" data-id="element-73">
            <div className="hidden md:block" data-id="element-74">
              <p className="text-white font-bold" data-id="element-75">{t('floating_title')}</p>
              <p className="text-sm text-gray-400" data-id="element-76">{t('floating_subtitle')}</p>
            </div>
            <div className="flex items-center gap-4 ml-auto" data-id="element-77">
              <div className="text-right hidden sm:block" data-id="element-78">
                <span className="text-[#D4A843] font-bold text-xl" data-id="element-79">
                  {t('floating_price')}
                </span>
                <span className="text-xs text-gray-500 block line-through" data-id="element-80">
                  $19.99
                </span>
              </div>
              <Button onClick={() => document.getElementById('pricing')?.scrollIntoView({
            behavior: 'smooth'
          })} className="shadow-lg" data-id="element-81">
                {t('floating_cta')}
              </Button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}